import moment from "moment";
export const dateFormatMMMDDYYYY = (d) => {
    const date = new Date(d);
    const formattedDate = moment(date).format('MMM DD, YYYY');
    return formattedDate;
};
